<ng-container [ngSwitch]="type">
    <p-card header="Telefonbuch Vorschau" *ngSwitchCase="'full'">
        <p>
            {{ contactData?.firstName }} {{ contactData?.lastName }}<br />
            {{ streetName }} {{ streetNumber }}<br />
            {{ postalCode }} {{ city }}<br />
            <ng-container *ngIf="portingData?.porting; else noPorting">
                06831 {{ portingData?.numbers![0] }}
            </ng-container>
            <ng-template #noPorting>
                * ihre neu vergebene Rufnummer *
            </ng-template>
        </p>
    </p-card>
    <p-card header="Telefonbuch Vorschau" *ngSwitchCase="'short'">
        <p>
            {{ contactData?.firstName }} {{ contactData?.lastName }}<br />
            {{ postalCode }} {{ city }}<br />
            <ng-container *ngIf="portingData?.porting; else noPorting">
                06831 {{ portingData?.numbers![0] }}
            </ng-container>
            <ng-template #noPorting>
                * ihre neu vergebene Rufnummer *
            </ng-template>
        </p>
    </p-card>
</ng-container>